<template>
  <nav id="navigation" ref="root" class="navbar navbar-default">
    <transition mode="out-in" name="slide-fade2" @afterEnter="onAfterEnter">
      <VSearch v-if="isSearch" @close="isSearch = false" />
      <div v-else class="container-fixed">
        <VueGlobalEvents v-if="isMenuOpen" @keyup.esc="onCollapseMenu" />
        <div :class="{ active: isMobileMenuOpen }" class="navbar-expanded">
          <div class="brandnavhead">
            <button class="btn btn-clean navbar-btn navbar-right" type="button" @click="onCollapseMenu">
              <span class="sr-only">{{ $t('common.close') }}</span>
              <span class="icon icon-cancel"></span>
            </button>
            <button v-show="isSubMenuOpen" class="btn btn-clean navbar-btn brandnav-control-up in" type="button" @click="expanded = '_mobileMainMenu'">
              <span class="sr-only">{{ $t('common.back') }}</span>
              <span class="icon icon-navigation-left"></span>
            </button>
            <label v-if="isSubMenuOpen" class="navbar-header-label brandnav-label" for="MainMenu" v-html="expanded"></label>
          </div>
          <div id="MainMenu" :class="{ 'has-active': isSubMenuOpen }" class="brandnav brandnav-lvl-1">
            <ul class="nav">
              <VAutoflat :expanded.sync="expanded" :is-navigation-flat="isNavigationFlat" :items="items" />
            </ul>
          </div>
        </div>
        <div class="navbar-persistent">
          <button class="btn btn-clean navbar-btn navbar-toggle" type="button" @click="onExpandMenu">
            <span class="sr-only">{{ $t('common.navigationOpen') }}</span>
            <span class="icon icon-list-view"></span>
          </button>
          <ul class="nav navbar-nav navbar-nav-icons navbar-right">
            <li v-if="isPerformExternalSearchAllowed">
              <a ref="search" :title="$tt('common.search')" class="navbar-brand" href="#" :aria-label="$tt('common.search')" @click.prevent="isSearch = true">
                <VSvgIcon name="search" variant="outlined" />
              </a>
            </li>
            <VLink :to="{ name: HOME }" active-class="">
              <VSvgIcon name="home" variant="outlined" size="middle" :aria-label="$t('common.aria_label_text_home')" />
            </VLink>
            <!--v-link :to="{ name: PROFILE }">
              <span class="sr-only">{{ $t('common.navigation_PROFILE') }}</span>
              <span class="icon icon-my-profile"></span>
            </v-link-->
            <VLoginStatusCaller :expanded.sync="expanded" />
          </ul>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import emitter from '@/plugins/emitter';
import VLink from '@/components/UI/Navigation/Link';
import VAutoflat from '@/components/UI/Navigation/Autoflat';

import { HOME } from '@route-types';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'UiNavigation',

  components: {
    VSvgIcon,
    VLink,
    VAutoflat,
    VLoginStatusCaller: () => import('./LoginStatusCaller'),
    VSearch: () => import('./Search'),
    VueGlobalEvents: () => import('vue-global-events'),
  },

  props: {
    isNavigationFlat: {
      type: Boolean,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      // Navigation:
      HOME,

      isHandlerRegistered: false,
      expanded: '_closed',
      isSearch: false,
    };
  },

  computed: {
    ...mapState('system', ['initComplete']),

    ...mapGetters('system', ['isPerformExternalSearchAllowed']),

    isMenuOpen() {
      return this.expanded !== '_closed';
    },

    isMobileMenuOpen() {
      return this.expanded === '_mobileMainMenu' || !this.expanded.startsWith('_');
    },

    isSubMenuOpen() {
      return !this.expanded.startsWith('_');
    },
  },

  watch: {
    $route: 'onCollapseMenu',
    expanded: 'onExpandChange',
  },

  created() {
    emitter.on('navigationReload', this.onCollapseMenu);
  },

  beforeDestroy() {
    emitter.off('navigationReload', this.onCollapseMenu);
  },

  methods: {
    clickOutside(event) {
      if (!(this.$refs.root === event.target || this.$refs.root?.contains(event.target))) {
        this.onCollapseMenu();
      }
    },

    onExpandChange() {
      if (this.expanded === '_closed') {
        if (this.isHandlerRegistered) {
          document.body.removeEventListener('click', this.clickOutside);
          this.isHandlerRegistered = false;
        }
      } else if (!this.isHandlerRegistered) {
        document.body.addEventListener('click', this.clickOutside);
        this.isHandlerRegistered = true;
      }
    },

    onExpandMenu() {
      this.expanded = '_mobileMainMenu';
    },

    onCollapseMenu() {
      this.expanded = '_closed';
    },

    onAfterEnter() {
      if (this.$refs.search) {
        this.$refs.search.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';

.nav {
  background-color: $modal-content-bgr;
}
</style>
